import { render, staticRenderFns } from "./JsryzcxxbgForm.vue?vue&type=template&id=a569ddd2"
import script from "./JsryzcxxbgForm.vue?vue&type=script&lang=js"
export * from "./JsryzcxxbgForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports